import { ThunkDispatch } from "redux-thunk";
import { IRootState } from "../store";
import { sessionCheck } from "./auth.thunk";
import {
  getAgeGroups,
  getAndroidVersion,
  getCountries,
  getInterests,
  getIosVersion,
  getLanguage,
  getStates,
} from "../../services/global";
import {
  getAgeGroupAction,
  getAgeGroupFailureAction,
  getAgeGroupSuccessAction,
  getAndroidVersionAction,
  getAndroidVersionFailureAction,
  getAndroidVersionSuccessAction,
  getCountriesAction,
  getCountriesFailureAction,
  getCountriesSuccessAction,
  getIOSVersionAction,
  getIOSVersionFailureAction,
  getIOSVersionSuccessAction,
  getInterestAction,
  getInterestFailureAction,
  getInterestSuccessAction,
  getLanguageFailureAction,
  getLanguageSuccessAction,
  getLanguageAction,
  IGlobalActions,
  getStatesAction,
  getStatesFailureAction,
  getStatesSuccessAction,
} from "../actions/global.action";

export const getIosVersionThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getIOSVersionAction());

      const list = await getIosVersion(auth.token);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getIOSVersionFailureAction(list.error));
      } else {
        dispatch(getIOSVersionSuccessAction(list.data));
      }
    }
  };

export const getCountriesThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    dispatch(getCountriesAction());

    const list = await getCountries();

    if (list.error && dispatch(sessionCheck(list))) {
      dispatch(getCountriesFailureAction(list.error));
    } else {
      dispatch(getCountriesSuccessAction(list.data));
    }
  };

export const getStatesThunk =
  (country: string) =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getStatesAction());

      const list = await getStates(auth.token, country);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getStatesFailureAction(list.error));
      } else {
        dispatch(getStatesSuccessAction(list.data));
      }
    }
  };

export const getAndroidVersionThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getAndroidVersionAction());

      const list = await getAndroidVersion(auth.token);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getAndroidVersionFailureAction(list.error));
      } else {
        dispatch(getAndroidVersionSuccessAction(list.data));
      }
    }
  };

export const getInterestsThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getInterestAction());

      const list = await getInterests(auth.token);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getInterestFailureAction(list.error));
      } else {
        dispatch(getInterestSuccessAction(list.data));
      }
    }
  };

export const getAgeGroupThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getAgeGroupAction());

      const list = await getAgeGroups(auth.token);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getAgeGroupFailureAction(list.error));
      } else {
        dispatch(getAgeGroupSuccessAction(list.data));
      }
    }
  };

export const getLanguageThunk =
  () =>
  async (
    dispatch: ThunkDispatch<IRootState, void, IGlobalActions>,
    getState: () => IRootState,
  ) => {
    const { auth } = getState();

    if (auth.token) {
      dispatch(getLanguageAction());

      const list = await getLanguage(auth.token);

      if (list.error && dispatch(sessionCheck(list))) {
        dispatch(getLanguageFailureAction(list.error));
      } else {
        dispatch(getLanguageSuccessAction(list.data));
      }
    }
  };
